import { createTheme } from '@mui/material/styles';
import { themePalette } from './palettle';
import { TypographyVariant } from './typography';

export const baseTheme = createTheme({
  palette: themePalette,
  typography: TypographyVariant,
});
